import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import Spinner from '../../../../components/Spinner'
import { Container } from './userInfoStyled';
import { Heading, TableWrapper, ButtonWrapper } from 'web/pages/private/Admin/adminStyled'
import { SelectWrapper, InnerBox } from 'web/pages/private/Admin/DashBoard/dashBoardStyled'

import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import { AddPromoCodeforUserApi, AddExistingPromoCodeforUserApi } from '../../../../../redux/actions/admin';

const AddPromoCodeforUser = ({ togglePage, fetchMyAPI, promoCodeList, updateNewPromoCodeListforUser }) => {

    let dispatch = useDispatch()
    let history = useHistory();
    let clickedCustomeId = localStorage.getItem("selectedCustomerID")
    let ClickedUserID = localStorage.getItem("selectedUserID")
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    let fromDate = new Date();
    let toDate = new Date();
    toDate.setDate(toDate.getDate() + 31);
    const [pageValueUpdates, setPageValueUpdates] = useState({
        newPromoCode: '',
        usageCount: '',
        discounttype: 'Free Subscription',
        benefitDuration: '',
        benefitType: 'Month',
        requireMinPruchase: false,
        eligibilityType: 'Selected Customers',
        customerId: '',
        discountValue: '',
        validityFrom: fromDate.toISOString().substr(0, 10),
        validityTo: toDate.toISOString().substr(0, 10),
        description: '',
    })
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [alertType, setAlertType] = useState('')
    const toggleModal = () => setModal(!modal);
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const toggleDropDown = () => setDropdownOpen(!dropdownOpen)
    const timeSpanSelect = [{ label: 'Days', value: 'Day' }, { label: 'Months', value: 'Month' }, { label: 'Years', value: 'Year' }]
    const checkStyle = { appearance: 'auto', marginRight: '5px', paddingTop: '24px', height: '15px', width: '15px', position: 'relative', top: '2px' }

    useEffect(() => {
        setPageValueUpdates({
            ...pageValueUpdates,
            customerId: clickedCustomeId ? clickedCustomeId : ''
        })
        localStorage.removeItem("selectedCustomerID")
    }, [])

    const handleChange = (e) => {
        const numberRegex = /^\d*\.?\d{0,2}$/;
        if (e.target.id === "usageCount" || e.target.id === "discountValue") {
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < 10001)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim()
                })
            }
        } else if (e.target.id === "benefitDuration") {
            let durationTime = 0
            if (pageValueUpdates.benefitType === 'Day') durationTime = 31
            else if (pageValueUpdates.benefitType === 'Month') durationTime = 12
            else durationTime = 2
            if (e.target.value === '' || (numberRegex.test(e.target.value) && parseInt(e.target.value) < durationTime)) {
                setPageValueUpdates({
                    ...pageValueUpdates,
                    [e.target.id]: e.target.value.trim()
                })
            }
        } else if (e.target.id === "requireMinPruchase") {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: !pageValueUpdates.requireMinPruchase
            })
        } else if (e.target.id === "benefitType") {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value.trim(),
                benefitDuration: ''
            })
        } else if (e.target.id === "description") {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value,
            })
        } else {
            setPageValueUpdates({
                ...pageValueUpdates,
                [e.target.id]: e.target.value.trim()
            })
        }
    }

    const submitPromoCode = async (e) => {
        if (pageValueUpdates.newPromoCode !== '' && pageValueUpdates.usageCount !== '' && pageValueUpdates.benefitDuration !== '' && pageValueUpdates.description !== '') {
            let data = {
                "generatePromoCode": pageValueUpdates.newPromoCode,
                "limitUsageCount": pageValueUpdates.usageCount === '' ? 0 : pageValueUpdates.usageCount,
                "discountType": pageValueUpdates.discounttype,
                "timeSpanForBenefits": {
                    "number": pageValueUpdates.benefitDuration === '' ? 0 : pageValueUpdates.benefitDuration,
                    "timeDMY": pageValueUpdates.benefitType
                },
                "customerEligibility": pageValueUpdates.eligibilityType,
                "customerID": pageValueUpdates.customerId,
                "applyStartDate": pageValueUpdates.validityFrom,
                "applyEndDate": pageValueUpdates.validityTo,
                "description": pageValueUpdates.description
            }
            if (parseInt(pageValueUpdates.usageCount) === 0 || parseInt(pageValueUpdates.benefitDuration) === 0) {
                setModalContent("Value should be greater than 0.");
                toggleModal();
            } else {
                let response = await dispatch(AddPromoCodeforUserApi(data))
                if (response.status === 'SUCCESS') {
                    fetchMyAPI()
                    setModalContent(response.message);
                    setAlertType('createPromoCode')
                    toggleModal();
                } else {
                    if (response.statusCode === 401) {
                        history.push('./sign-in')
                        window.location.reload(false);
                    } else {
                        setModalContent(response.message);
                        toggleModal();
                    }
                }
            }
        } else {
            setModalContent("Please fill the required fields.");
            setAlertType('')
            toggleModal();
        }
    }

    const addExistingCode = async (data, index) => {
        let content = {
            "generatePromoCode": data.promoCode,
            "customerID": pageValueUpdates.customerId
        }
        let response = await dispatch(AddExistingPromoCodeforUserApi(content))
        if (response.status === 'SUCCESS') {
            fetchMyAPI()
            setModalContent(response.message);
            setAlertType('createPromoCode')
            toggleModal();
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                toggleModal();
            }
        }
    }

    return (
        <div>
            <Container>

                {loaderVisible && <Spinner />}
                <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                    <ButtonDropdown isOpen={dropdownOpen} toggle={toggleDropDown}>
                        <DropdownToggle caret>
                            Add Existing Code
                        </DropdownToggle>
                        <DropdownMenu style={{ overflow: 'auto', height: '335px' }}>
                            {promoCodeList.map((data, index) => {
                                return (
                                    <DropdownItem
                                        onClick={() => addExistingCode(data, index)}
                                    >{data.promoCode}</DropdownItem>
                                )
                            })}
                        </DropdownMenu>
                    </ButtonDropdown>
                </div>
                <TableWrapper>
                    <Heading>
                        <h3>Generate Promo Code</h3>
                    </Heading>
                    <InnerBox>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Generate Promo Code<span className='star'>*</span></label>
                                        <input required id='newPromoCode' placeholder='Enter a new code...' value={pageValueUpdates.newPromoCode.substring(0, 50)} onChange={handleChange} />
                                    </SelectWrapper>
                                </div>
                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Limit Usage Count<span className='star'>*</span></label>
                                        <input required id='usageCount' placeholder='Usage Count' value={pageValueUpdates.usageCount} onChange={handleChange} />
                                    </SelectWrapper>
                                </div>
                            </div>
                        </div>
                    </InnerBox>
                </TableWrapper>
                <TableWrapper>
                    <Heading>
                        <h3>Discount Type</h3>
                    </Heading>
                    <InnerBox>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Discount Type<span className='star'>*</span></label>
                                        <select id='discounttype' value={pageValueUpdates.discounttype}
                                            onChange={handleChange}>
                                            <option value='Free Subscription'>Free Subscription</option>
                                            {/* <option value='Percentage discount in subscription fee'>Percentage discount in subscription fee</option> */}
                                        </select>
                                    </SelectWrapper>
                                </div>
                                {/* <div className='col-md-4 col-sm-6'>
                                            <SelectWrapper>
                                                <label>Discount Value<span className='star'>*</span></label>
                                                <input required id='discountValue' placeholder='Discount Value' value={pageValueUpdates.discountValue} onChange={handleChange} />
                                            </SelectWrapper>
                                        </div> */}
                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Time Span for benefits<span className='star'>*</span></label>
                                        <div className='row' style={{ marginLeft: '0px' }}>
                                            <input required id='benefitDuration' value={pageValueUpdates.benefitDuration} placeholder='No. of' onChange={handleChange} />
                                            <label>&nbsp;</label>
                                            <select id='benefitType' value={pageValueUpdates.benefitType}
                                                onChange={handleChange}
                                            >
                                                {timeSpanSelect.map(val => (
                                                    <option value={val.value}>{val.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </SelectWrapper>
                                </div>
                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Validity<span className='star'>*</span></label>
                                        <div className='row' style={{ marginLeft: '0px' }}>
                                            <input type='date' max={pageValueUpdates.validityTo} id='validityFrom' value={pageValueUpdates.validityFrom} onChange={handleChange} />
                                            <label style={{ margin: '6px' }}>To&nbsp;</label>
                                            <input type='date' min={pageValueUpdates.validityFrom} id='validityTo' value={pageValueUpdates.validityTo} onChange={handleChange} />
                                        </div>
                                    </SelectWrapper>
                                </div>
                            </div>
                            {/* <div className='row'>
                                        <div className='col-md-8 col-sm-6'>
                                            <input disabled style={checkStyle} type="checkbox" id='requireMinPruchase' checked={pageValueUpdates.requireMinPruchase} onChange={handleChange} />
                                            <label>Discount require a minimum purchase.</label>
                                        </div>
                                    </div> */}
                        </div>
                    </InnerBox>
                </TableWrapper>
                <TableWrapper>
                    <Heading>
                        <h3>Customer Eligibility</h3>
                    </Heading>
                    <InnerBox>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Eligibility Type<span className='star'>*</span></label>
                                        <select id='eligibilityType' value={pageValueUpdates.eligibilityType}
                                            onChange={handleChange}>
                                            <option value='Everyone'>Everyone</option>
                                            <option value='New Registration'>New Registration</option>
                                            <option value='Selected Customers'>Selected Customers</option>
                                        </select>
                                    </SelectWrapper>
                                </div>
                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Customer ID<span className='star'>*</span></label>
                                        <input required disabled id='customerId' value={pageValueUpdates.customerId} onChange={handleChange} />
                                    </SelectWrapper>
                                </div>

                                <div className='col-md-4 col-sm-6'>
                                    <SelectWrapper>
                                        <label>Description<span className='star'>*</span></label>
                                        <input required id='description' value={pageValueUpdates.description} onChange={handleChange} />
                                    </SelectWrapper>
                                </div>
                            </div>
                        </div>
                    </InnerBox>
                </TableWrapper>
                <ButtonWrapper>
                    <Button
                        type='app-green-button submitBtn'
                        handleClick={() => togglePage('UsersPromoCodeList')}
                    >
                        Back
                    </Button>
                    <Button
                        type='app-green-button submitBtn'
                        handleClick={e => submitPromoCode(e)}
                    >
                        Create Promo Code
                    </Button>
                </ButtonWrapper>
            </Container>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=''
                content={modalContent}
                alertType={alertType}
                callBackAlert={() => {
                    updateNewPromoCodeListforUser(ClickedUserID)
                }}
            />
        </div >
    )
};

export default AddPromoCodeforUser;